import React, { useEffect } from 'react';

import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { GoBackArrowBtn } from '@/components/GoBackArrowBtn/GoBackArrowBtn';
import { Loader } from '@/components/Loader/loader';
import PartnerGrid from '@/components/PartnerGrid/PartnerGrid';
import PrivateStockExchangeAccess from '@/components/PrivateStockExchangeAccess/PrivateStockExchangeAccess';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { ROUTE } from '@/constants/route';
import { URLS } from '@/constants/urls';
import { useAuth } from '@/hooks/useAuth';
import { usePartnersCatalog } from '@/hooks/usePartnersCatalog';
import useScreenSize from '@/hooks/useScreenSize';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

export const AutresAcces: React.FC = () => {
  const { windowWidth } = useScreenSize();
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const { gestionnaires, isLoading, isError } = usePartnersCatalog();

  useEffect(() => {
    if (sessionStorage.getItem('parcoursVersementData')) {
      sessionStorage.removeItem('parcoursVersementData');
    }
  }, []);

  useEffect(() => {
    TRACKING_INSTANCE.setTcVars({
      page_nom: 'mes autres acces',
      page_template: 'espace client',
      user_id: user?.id,
      user_client: user?.type === 'Client',
      user_connexion: user?.success,
      user_statut_contrat: sessionStorage.getItem('user_statut_contrat'),
    });
    void TRACKING_INSTANCE.triggerEvent('page', undefined, {
      event_id: 'page',
      event_categorie: 'affichage espace client',
      event_nom: 'mes autres acces',
      event_page: 'mes autres acces',
    });
    globalThis.scrollTo({ top: 0, behavior: 'smooth' });
  }, [user]);

  useEffect(() => {
    if (!isError) return;
    navigate(ROUTE.ERREUR, { state: { goTo: ROUTE.DASHBOARD } });
  }, [isError, navigate]);

  const handleDiscoverClick = () => {
    void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'acceder bourse privee',
      event_detail_1: 'cta',
      event_detail_2: 'bourse privee',
    });
  };

  if (isError) return null;

  return (
    <div className={styles.autresAcces}>
      <MtxGrid row className={styles.autresAccesHead}>
        {windowWidth <= BREAKPOINTS.tablet && <GoBackArrowBtn />}
        <MtxGrid col={12} offset={0}>
          <h1>{t('autresAcces.title')}</h1>
        </MtxGrid>
      </MtxGrid>

      <div className={styles.sections}>
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>{t('autresAcces.gestionnairesTitle')}</h2>
            <p className={styles.sectionDescription}>{t('autresAcces.gestionnairesDescription')}</p>
          </div>

          {isLoading ? <Loader /> : <PartnerGrid data={gestionnaires} trackingContext="autres-acces" />}
        </section>

        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>{t('autresAcces.bourseTitle')}</h2>
            <p className={styles.sectionDescription}>
              <Trans
                i18nKey="autresAcces.bourseDescription"
                components={{
                  link: (
                    <a
                      href={URLS.PRIVATE_STOCK_EXCHANGE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.sectionDescriptionLink}
                      aria-label={t('autresAcces.bourseDescriptionLinkLabel')}
                      onClick={handleDiscoverClick}
                    />
                  ),
                }}
              />
            </p>
          </div>
          <PrivateStockExchangeAccess />
        </section>
      </div>
    </div>
  );
};
